import React, { Component } from 'react';
import Content from '../../_core/components/Content';
import Icon from '../../_core/components/Icon';
import Link from '../../_core/components/Link';
import { BsLinkedin } from "react-icons/bs";

class Com extends Component {


  constructor(props){

      super(props);
  }

  componentDidMount = () => {

      const _this = this;

  }

  render() {    

    return (
      
        <div className="Footer" data-layout>

            <div className="Footer-derwent">
              <a href="https://www.derwentlondon.com/" target="_blank"><Icon glyph type={'derwent'} /></a>
            </div>

             <div className="Footer-misrep">
                <ul className="List List--inline">
                  <li><Content><h3><a href={`#/misrep/`}>Misrep Act</a></h3></Content></li>
                  <li><Content><h3><a href={`/cookies/`}>Cookie Preferences</a></h3></Content></li>
                  <li><Content><h3><a href={`https://www.derwentlondon.com/texts/privacy-policy`}>Privacy Policy</a></h3></Content></li>
                </ul>
             </div>
           
            <div className="Footer-social">
              <ul className="List List--inline">

                <li><a href="https://www.linkedin.com/company/derwentlondon/" target="_blank"><BsLinkedin /></a></li>
                <li><a href="https://www.instagram.com/derwent_london/" target="_blank"><Icon glyph type={'instagram'} /></a></li>
                <li><a href="http://www.facebook.com/derwentlondon" target="_blank"><Icon glyph type={'facebook'} /></a></li>
                <li><a href="http://www.twitter.com/derwentlondon" target="_blank"><Icon glyph type={'twitter'} /></a></li>

              </ul>
            </div>
         
        </div>
               
    );
  }
}



export default Com;



// WEBPACK FOOTER //
// ./src/js/components/_layouts/Footer.js